import { useBrandFactsSetupStore } from '@/stores/setup-brand-facts'
import { useCompetitorsSetupStore } from '@/stores/setup-competitors'
import { useContentStrategySetupStore } from '@/stores/setup-content-strategy'
import { useCustomerProfileSetupStore } from '@/stores/setup-customer-profile'
import { useVisualStyleSetupStore } from '@/stores/setup-visual-style'
import type { Activity } from '@/types/activity'
import type { OnboardingChainStep, StepConfirmation } from '@/types/onboarding-chain'

export interface SetupStepSource {
  readonly resolved: boolean
  readonly readFailed: boolean
  readonly confirmation: StepConfirmation
  readonly activity: Activity
  open(): void
  close(): void
  resumeIndex(): number
}

export const SETUP_STEP_SOURCES: Readonly<
  Partial<Record<OnboardingChainStep, () => SetupStepSource>>
> = {
  'brand-facts': useBrandFactsSetupStore,
  competitors: useCompetitorsSetupStore,
  'customer-profile': useCustomerProfileSetupStore,
  strategy: useContentStrategySetupStore,
  'visual-style': useVisualStyleSetupStore,
}
